import React from 'react';
import Checkbox from 'components/Checkbox';
import Spinner from 'components/Spinner';
import { ReactComponent as SvgImagePlayButton } from 'assets/svg/Play.svg';
import { Container, ChatItem, PlayContainer } from './styles';
import colors from 'constants/colors';
import { useQuery } from '@apollo/client';
import { GET_MESSAGES_BY_PAGESIZE_AND_PAGE_NUMBER } from 'graphql/service';

const CommunicationHistory = ({ tenantId}) => {

  const {data, loading} = useQuery(GET_MESSAGES_BY_PAGESIZE_AND_PAGE_NUMBER,
    {
      variables: {
        tenantId: tenantId,
        input: {
          pagination: {
            limit: 1000,
            offset: 0
          }
        }
      }
    }
  );

  if (loading) {
    return <Spinner />
  }

  return (
    <Container>
      <div className='title'>Tenant Communication History</div>
      <table>
        <thead>
          <tr>
            <th className="sign"></th>
            <th className="dateTime">DATE / TIME</th>
            <th className="type">TYPE</th>
            <th className="agent">AGENT</th>
            <th className="details">DETAILS</th>
            <th className="playback">PLAYBACK</th>
          </tr>
        </thead>
        <tbody>
          <tr className="highlight">
            <td>
              <Checkbox
                backgroundColor={colors.black2}
                checkColor={colors.green}
                checked={false}
                onChange={() => { }}
              />
            </td>
            <td>10/5/2020 5:24 PM</td>
            <td>Email</td>
            <td>John Smith</td>
            <td>
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
              minim veniam, quis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
              pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
              culpa qui officia deserunt mollit anim id est laborum.”{' '}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <Checkbox
                backgroundColor={colors.black2}
                checkColor={colors.green}
                checked={true}
                onChange={() => { }}
              />
            </td>
            <td>10/5/2020 5:24 PM</td>
            <td>Web</td>
            <td>John Smith</td>
            <td>
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.”
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <Checkbox
                backgroundColor={colors.black2}
                checkColor={colors.green}
                checked={true}
                onChange={() => { }}
              />
            </td>
            <td>10/5/2020 5:24 PM</td>
            <td>Chat</td>
            <td colSpan="2">
              <ChatItem color={`${colors.lightBlue}`}>
                <span className="chatItem">
                <span className="chatAgent">
                  Staff
                </span>
                <span className="chatDetails">
                  “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                  minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                  aliquip ex ea commodo consequat. Duis aute irure dolor in
                  reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                  pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                  culpa qui officia deserunt mollit anim id est laborum.”{' '}
                </span>
                </span>
              </ChatItem>
              <ChatItem color={`${colors.green}`}>
              <span className="chatItem">
                <span className="chatAgent">
                  Joe B.
                </span>
                <span className="chatDetails">
                  “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                  eiusmod.”
                </span>
                </span>
              </ChatItem>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <Checkbox
                backgroundColor={colors.black2}
                checkColor={colors.green}
                checked={true}
                onChange={() => { }}
              />  
            </td>
            <td>10/5/2020 5:24 PM</td>
            <td>SMS</td>
            <td>Joe B.</td>
            <td>
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.”
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <Checkbox
                backgroundColor={colors.black2}
                checkColor={colors.green}
                checked={true}
                onChange={() => { }}
              />
            </td>
            <td>10/5/2020 5:24 PM</td>
            <td>Phone</td>
            <td>Joe B.</td>
            <td>
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod.”
            </td>
            <td>
              <PlayContainer>
                <SvgImagePlayButton />
                <span>4:34</span>
              </PlayContainer>
            </td>
          </tr>
        </tbody>
      </table>
    </Container>
  )
}

export default CommunicationHistory;
